import { render, staticRenderFns } from "./BldAdmDataSource.vue?vue&type=template&id=8161a53e&scoped=true&"
import script from "./BldAdmDataSource.vue?vue&type=script&lang=js&"
export * from "./BldAdmDataSource.vue?vue&type=script&lang=js&"
import style0 from "./BldAdmDataSource.vue?vue&type=style&index=0&id=8161a53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8161a53e",
  null
  
)

export default component.exports